import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { scrollToTarget, NAV_OFFSET } from '../lib/scrollController'

export default function AnchorScrollHandler() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const onClick = (e) => {
      // Never hijack a click the browser or another handler already owns.
      if (
        e.defaultPrevented ||
        e.button !== 0 ||
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey ||
        e.altKey
      ) return

      const anchor = e.target.closest('a[href]')
      if (!anchor) return
      const href = anchor.getAttribute('href')
      if (!href) return
      // Let the browser open new tabs/windows with the anchor intact.
      if (anchor.target && anchor.target !== '_self') return

      const isHashOnly = href.startsWith('#')
      const isPathHash = /^\/#/.test(href)

      if (isHashOnly) {
        e.preventDefault()
        scrollToTarget(href, NAV_OFFSET)
        return
      }

      if (isPathHash) {
        const [, section] = href.split('#')
        e.preventDefault()
        if (location.pathname === '/') {
          scrollToTarget(`#${section}`, NAV_OFFSET)
        } else {
          navigate('/')
          setTimeout(() => scrollToTarget(`#${section}`, NAV_OFFSET), 100)
        }
      }
    }

    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [location.pathname, navigate])

  return null
}
